import {lazy, Suspense} from 'react';
import LoadingPage from '../containers/loading';

const Page = lazy (() => import ('../containers/prices'));

function PricesRoute () {
  return (
    <Suspense fallback={<LoadingPage />}>
      <Page />
    </Suspense>
  );
}

export default PricesRoute;
